import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VirtualListViewportComponent } from './virtual-list-viewport/virtual-list-viewport.component';
import { VirtualGridViewportComponent } from './virtual-grid-viewport/virtual-grid-viewport.component';
import { FrameGridLayoutComponent } from './frame-grid-layout/frame-grid-layout.component';

@NgModule({
  declarations: [
    VirtualListViewportComponent,
    VirtualGridViewportComponent,
    FrameGridLayoutComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    VirtualListViewportComponent,
    VirtualGridViewportComponent,
    FrameGridLayoutComponent,
  ],
})
export class VirtualizationModule {
}
